module.exports = __webpack_public_path__ + "static/img/2.6306203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/culturalCourses/2.png
// module id = A/52
// module chunks = 0